// Shared UK registration validation — MUST stay in sync with the server-side
// rules in backend/models.py (validate_uk_registration).
// Formats: current AB12CDE · prefix A123BCD · suffix ABC123D ·
// dateless 1ABC/ABC1/12AB/AB12/123ABC/ABC123/1234AB/AB1234 · NI ABZ1234.
export const UK_PLATE_RE = /^(?:[A-Z]{2}[0-9]{2}[A-Z]{3}|[A-Z][0-9]{1,3}[A-Z]{3}|[A-Z]{3}[0-9]{1,3}[A-Z]|[0-9]{1,4}[A-Z]{1,3}|[A-Z]{1,3}[0-9]{1,4})$/;

export const normalizePlate = (raw) => (raw || "").toUpperCase().replace(/[\s-]/g, "");

export const isValidUkPlate = (raw) => UK_PLATE_RE.test(normalizePlate(raw));
